import { Producto } from './Producto';

export class StockPorContenedores{
    producto: Producto;
    volumenEnTanques: number;
    volumenEnPoliductos: number;
    volumenEnAbastecedoras: number;
    volumenEnCanerias: number;
    warnings: [];
}